import { LogicNodeDefinition } from '../LogicNodeDefinition';

interface ConsoleState {
  lastInput: boolean | null;
}

export const ConsoleNode: LogicNodeDefinition<ConsoleState> = {
  type: 'CONSOLE',
  createDefaultState: () => ({ lastInput: null }),
  process: (input, state) => {
    if (input !== state.lastInput) {
      console.log('CONSOLE NODE:', input);
      state.lastInput = input;
    }
    return input;
  },
};
